// extracted by mini-css-extract-plugin
export default {"container":"TextEditor_container__+wYk8","toolsBlock":"TextEditor_toolsBlock__WOWLD","charactersLimit":"TextEditor_charactersLimit__4LIFb","active":"TextEditor_active__4EuG8"};